import * as React from 'react';
import { FunctionComponent } from 'react';
import moment from 'moment';
import './GeneralMessagePreview.css';

interface Props {
  messagePushTitle: string;
  messagePushBody: string;
  showTitle?: boolean;
}

export const GeneralMessagePreviewPush: FunctionComponent<Props> = props => {
  const currentTime = moment(new Date()).format('HH:mm');

  return (
    <div className="gmPreviewDevice">
      <div className="gmPreviewDevice__time">{currentTime}</div>
      <div className="gmPreviewPushCard">
        <div className="gmPreviewPushCard__top">
          <img className="gmPreviewPushCard__logo" src="/dist/images/logoImage.png" alt="" />
          <span className="gmPreviewPushCard__app">Squad In Touch</span>
          <span className="gmPreviewPushCard__now">now</span>
        </div>
        <div className="gmPreviewPushCard__title">{props.messagePushTitle || 'Notification title'}</div>
        <div className="gmPreviewPushCard__body">{props.messagePushBody || 'No push content yet.'}</div>
      </div>
    </div>
  );
};
